module.exports = __webpack_public_path__ + "img/logo.7069302e.png";